export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/hooks/useAuth.ts"